import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded'
import PersonRounded from '@mui/icons-material/PersonRounded'
import classNames from 'classnames'
import { Button } from 'ui'

import style from './LoginBlock.module.scss'

interface LoginBlockProps {
  className?: string
  onLoginClick: () => void
}

// блок входа в личный кабинет
export function LoginBlock({ className, onLoginClick }: LoginBlockProps) {
  return (
    <div className={classNames(className, style.box)}>
      <p className={classNames('h3 m0', style.header)}>
        <PersonRounded className={style.headerIcon} />
        войти в личный кабинет
      </p>
      <p className={style.text}>
        Уже являетесь нашим клиентом или хотите присоединиться?
      </p>
      <Button
        variant='contained'
        size='large'
        className={style.btn}
        endIcon={<ChevronRightRounded />}
        onClick={onLoginClick}
        data-testid='main-auth-button'
      >
        Войти
      </Button>
    </div>
  )
}
